import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=9c5793ce&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=ts"
export * from "./NewsItem.vue?vue&type=script&lang=ts"
import style0 from "./NewsItem.vue?vue&type=style&index=0&id=9c5793ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5793ce",
  null
  
)

export default component.exports